import apiClient from "../client";
const ENDPOINT = "/uploads"

export const filesApi = {
    upload: (payload) => apiClient.post(`${ENDPOINT}/presigned-url`, payload),
    view: (payload) => apiClient.post(`${ENDPOINT}/download-url`, payload),
};